import { useForm } from 'react-hook-form'
import { useParamsList } from 'src/hooks/useParamsList.hook'
import { TermsListSpace } from 'src/types/api'
import { FormObjectType, JoinFormType, otpCertItemsForm } from 'src/types/react-hook-form'
import { NumReplace } from 'src/service/utils/strReg'
import { certNumberPattern, pNumberPattern } from 'src/service/utils/strReg'
import { useState } from 'react'
import usePcodeMatch from 'src/hooks/usePcodeMatch.hook'
import { createTermsAttribute } from './shared/createTermsAttribute'
import { otpCertDefaultValues, telecomConverter, termsDefaultValues } from './shared/termsConstants'
import { useTermsAgreement } from './shared/useTermsAgreement'

export { telecomConverter } from './shared/termsConstants'

const useDefaultJoinForm = (termsQueryData?: TermsListSpace.Response) => {
  const { bill_letter } = usePcodeMatch()
  const { telecom, fixedTelecom } = useParamsList()
  const telecomValue = fixedTelecom || telecom
  const telecomName = telecomConverter[telecomValue as string]
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false)
  const [termsUrl, setTermsUrl] = useState<string | null>(null)

  const termsData =
    (termsQueryData?.[telecomName] as TermsListSpace.AllTermsType & { Idx: number }) ||
    termsDefaultValues

  const methods = useForm<JoinFormType>({
    mode: 'onSubmit',
    defaultValues: { ...otpCertDefaultValues, ...termsDefaultValues },
  })

  const { setValue } = methods

  const { requiredTermsList, allTermsAgreeHandler, updateAllTermsAgree } = useTermsAgreement(
    termsData,
    methods,
  )

  const handleShowPopupOpen = (termsKey: string) => {
    const url = `${window.location.origin}/terms/${telecomValue}/${termsKey}`
    if (bill_letter) {
      // 앱 웹뷰: 앱이 약관 페이지 열도록 이벤트 전달
      window.location.href = `sendEventToApp:onClickedOutPage=${url}`
      return
    }
    setTermsUrl(url)
    setIsTermsModalOpen(true)
  }

  const termsAttribute = createTermsAttribute({
    termsData,
    telecomValue,
    updateAllTermsAgree,
    allTermsAgreeHandler,
    showTermsPopup: handleShowPopupOpen,
  })

  const otpCertAttribute: Record<keyof otpCertItemsForm, Partial<FormObjectType>> = {
    TranID: {
      tag: 'TranID',
      register_options: { required: true },
    },
    PNumber: {
      tag: 'PNumber',
      type: 'tel',
      register_options: {
        required: '휴대폰번호를 정확하게 입력하여 주십시오.',
        onChange: (event: { target: { value: string } }) => {
          setValue('PNumber', NumReplace(event.target.value, 11), {
            shouldValidate: true,
          })
        },
        pattern: { value: pNumberPattern, message: '휴대폰번호를 정확하게 입력하여 주십시오.' },
        minLength: { value: 11, message: '휴대폰번호를 정확하게 입력하여 주십시오.' },
        maxLength: { value: 11, message: '휴대폰번호를 정확하게 입력하여 주십시오.' },
        inputMode: 'numeric',
      },
    },
    ApprovalNumber: {
      tag: 'ApprovalNumber',
      type: 'tel',
      register_options: {
        required: false,
        onChange: (event: { target: { value: string } }) => {
          setValue('ApprovalNumber', NumReplace(event.target.value, 4), {
            shouldValidate: true,
          })
        },
        minLength: { value: 1, message: '인증번호를 입력해주세요.' },
        pattern: { value: certNumberPattern, message: '인증번호를 정확하게 입력하여 주십시오.' },
        inputMode: 'numeric',
      },
    },
  }

  return {
    methods,
    registerAttribute: { ...termsAttribute, ...otpCertAttribute },
    requiredTermsList,
    allTermsAgreeHandler,
    termsData,
    isTermsModalOpen,
    setIsTermsModalOpen,
    termsUrl,
    setTermsUrl,
  }
}

export default useDefaultJoinForm
